<template>
  <router-view/>
</template>
<script>

import { getConfigInfo } from "@/service/omg/publicInfo";

export default {
  components: {},
  props: {},
  provide() {
    return {
      configInfo: this.configInfo
    };
  },
  data() {
    return {
      configInfo: {
        "project": "",
        "title": "",
        "login_logo": "",
        "login_logo_desc": "",
        "copyright": "",
        "show_forget_password_tip": true,
        "show_forget_password": "",
        "show_omg_login": true,
        "main_logo": "",
        "main_logo_text": "",
        "ico": ""
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    async initConfigInfo() {
      const configInfo = await getConfigInfo();
      console.log('initConfigInfo', configInfo);
      if (configInfo) {
        //
        Object.keys(configInfo).forEach(key => {
          const value = configInfo[key];
          this.$set(this.configInfo, key, value);
        });
        //
        if (configInfo.title) {
          document.title = configInfo.title;
        }
        //
        if (configInfo.ico) {
          const link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = configInfo.ico;
          document.head.appendChild(link);
        }
      }
    }
  },
  created() {
    this.initConfigInfo();
  },
  mounted() {
  },
  beforeDestroy() {
  }
}
</script>

<style lang="scss" scoped>

</style>
